var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"mb-6 mb-lg-10",class:[_vm.textClass ? _vm.textClass : 'secondary--text'],staticStyle:{"line-height":"120%"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }